import { hideOnError } from '@Util/imageUtils';
import React from 'react';

interface ContainerProps extends React.HTMLProps<HTMLDivElement> {
    children: React.ReactNode;
}

export const TaxCardMainTableSvgContainer = ({ children, ...props }: ContainerProps) => {
    return (
        <div
            className="TaxCardMainTable-icon__container atl-flex atl-flex-col atl-items-center atl-justify-center"
            {...props}
        >
            {children}
        </div>
    );
};

export const TaxCardMainTableError = () => {
    return (
        <div className="TaxCardMainTable-icon__circle atl-mb-16">
            <svg xmlns="http://www.w3.org/2000/svg" height="50px" viewBox="0 0 24 19" width="48px" fill="#e83645">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
            </svg>
        </div>
    );
};

export const TaxCardMainTableNoEmployees = () => {
    return (
        <div className="taxCardMainTable-icon atl-mb-16">
            <img src="/resources/imgs/ghost.svg" alt="" onError={hideOnError} />
        </div>
    );
};
